"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var TextInput_vue_1 = __importDefault(require("../Input/TextInput.vue"));
var TextOutput_vue_1 = __importDefault(require("../Output/TextOutput.vue"));
var TextMultiline_vue_1 = __importDefault(require("../Input/TextMultiline.vue"));
var Number_vue_1 = __importDefault(require("../Input/Number.vue"));
var UploadFile_vue_1 = __importDefault(require("../Input/UploadFile.vue"));
var DatepickerDate_vue_1 = __importDefault(require("../Input/DatepickerDate.vue"));
var FileListOutput_vue_1 = __importDefault(require("../Output/FileListOutput.vue"));
var Row_vue_1 = __importDefault(require("../Layout/Row.vue"));
var Column_vue_1 = __importDefault(require("../Layout/Column.vue"));
var ControlIteration_1 = __importDefault(require("../../Mixins/ControlIteration"));
exports.default = vue_1.default.extend({
    props: ['name', "index", "datas", "bcTransfos"],
    mixins: [ControlIteration_1.default],
    components: { TextInput: TextInput_vue_1.default, DatepickerDate: DatepickerDate_vue_1.default, TextMultiline: TextMultiline_vue_1.default, UploadFile: UploadFile_vue_1.default, NumberInput: Number_vue_1.default, HeColumn: Column_vue_1.default, HeRow: Row_vue_1.default, TextOutput: TextOutput_vue_1.default, FileList: FileListOutput_vue_1.default },
    data: function () {
        var data = this.datas || {};
        var bcIdNeuf = (this.$root.$data.data && this.$root.$data.data['Items'] && this.$root.$data.data['Items'][this.index]['bonCommandeIdNeuf']);
        return {
            gestionTransfoId: data.gestionTransfoId || "",
            puissance: data.puissance || (this.datas === null ? "puissance" : ""),
            tpc: data.tpc || false,
            type: data.type || (this.datas === null ? "type" : ""),
            numPoste: data.numPoste || (this.datas === null ? "numPoste" : ""),
            nomPoste: data.nomPoste || (this.datas === null ? "nomPoste" : ""),
            marque: data.marque || "",
            numeroSerie: data.numeroSerie || "",
            anneeFabrication: data.anneeFabrication || "",
            dateLivraison: data.dateLivraison || "",
            bonCommandeIdNeuf: bcIdNeuf || data.bonCommandeIdNeuf,
            masseTotale: data.masseTotale || "",
            masseDielectrique: data.masseDielectrique || "",
            masseSolide: data.masseSolide || "",
            commentaire: data.commentaire || "",
            bonLivraison: data.bonLivraison || [],
            numGestionEntreprise: data.numGestionEntreprise || "",
            internalReadOnly: data.readOnly || false,
        };
    },
    methods: {
        getBcCommandIdNeuf: function () {
            var bcTransfo = this.bonCommandeIdNeuf || (this.$root.$data.data && this.$root.$data.data['Items'] && this.$root.$data.data['Items'][this.index]['bonCommandeIdNeuf']);
            this.$emit("bctransfo", bcTransfo);
            return bcTransfo;
        },
        updateMasseSolide: function () {
            var mtotale = this.$refs.mtotale.value, mdielec = this.$refs.mdielec.value;
            this.$refs.msolide.value = !isNaN(mdielec) && !isNaN(mtotale) ? mtotale - mdielec : "";
        },
        getBcTransfo: function () {
            var _this = this;
            var self = this;
            $.ajax({
                url: '/Affaires/GetBcTransfo',
                type: 'get',
                data: {
                    id: self.gestionId,
                    affaireId: self.$root.$data.affaireId
                },
            }).done(function (data) {
                self.$refs.files.files = data.data && data.data !== "[]" ? JSON.parse(data) : (!_this.$root.$data.affaireId ? [{
                        fileName: "Test.pdf",
                        fileSize: 12000,
                        tags: [],
                        publicId: "00000000-0000-0000-0000-000000000000",
                        url: ""
                    }] : []);
            });
        }
    },
    mounted: function () {
        var _this = this;
        this.$watch(function () { return _this.$refs.mtotale.value; }, function () { _this.updateMasseSolide(); });
        this.$watch(function () { return _this.$refs.mdielec.value; }, function () { _this.updateMasseSolide(); });
        this.getBcTransfo();
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./_wwwsrc/js/Workflow/Components/SpecificComponents/ReceptionTransformateur.vue
// module id = 214
// module chunks = 0